import type { ReactNode } from "react";

/** A right-aligned action bar — the `fawkes-action-bar` vocabulary (e.g. Save / Cancel). */
export function ActionBar({ children }: { children: ReactNode }) {
  return <div className="fui-action-bar">{children}</div>;
}
